import { render, staticRenderFns } from "./EmployeeNameFormatSwitcher.vue?vue&type=template&id=256ccb17&scoped=true&"
import script from "./EmployeeNameFormatSwitcher.vue?vue&type=script&lang=js&"
export * from "./EmployeeNameFormatSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeNameFormatSwitcher.vue?vue&type=style&index=0&id=256ccb17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256ccb17",
  null
  
)

export default component.exports